import Hero from "../components/Hero";
import FeaturedProducts from "../components/FeaturedProducts";
import TestimonialsCarousel from "../components/TestimonialsCarusel"
import { useProducts } from "../context/ProductsContext";
import { productsHero } from "../data/homeSlides";
import Search from "./Search";

export default function Home() {
  const { products } = useProducts();

  return (    
    <div>
      {/* Pasás los productos al Hero y FeaturedProducts */}
      <Hero products={productsHero} />
      <div id="main" className="pt-8">
      <Search products={products}/>
      </div>
       <TestimonialsCarousel color="#d24e1e" />
    </div>
  );
}
